module.exports = __webpack_public_path__ + "img/story-detail-avator.3971fe01.svg";